import React, { ReactElement, useEffect } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import ReactTooltip from 'react-tooltip';

import { selectIsPartnersDashboard } from '../../../store/slices/global.slice';
import { selectSession } from '../../../store/slices/sessions.slice';
import SessionFilesModal from '../../Molecules/SessionFilesModal/SessionFilesModal';
import CustomerSessionDetails from './components/CustomerSessionDetails/CustomerSessionDetails';
import PartnerSessionDetails from './components/PartnerSessionDetails/PartnerSessionDetails';

interface SessionDetailsInterface {
  musicianConfiguration: any;
  onPanelClose: () => void;
}

const SessionDetails = ({ musicianConfiguration, onPanelClose }: SessionDetailsInterface): ReactElement => {
  const isPartnersDashboard = useSelector(selectIsPartnersDashboard, shallowEqual);
  const session = useSelector(selectSession, shallowEqual);

  const sessionId = session.id;
  const sessionTrack = session.session_info?.title;

  useEffect((): void => {
    window.history.replaceState(null, '', `/sessions/${sessionId}`);
  }, [sessionId]);

  return (
    <>
      {isPartnersDashboard ? (
        <PartnerSessionDetails onPanelClose={onPanelClose} />
      ) : (
        <CustomerSessionDetails
          musicianConfiguration={musicianConfiguration}
          onPanelClose={onPanelClose} />
      )}
      <SessionFilesModal
        customerName={session.user?.name}
        partnerName={session.partner?.name}
        trackName={sessionTrack}
        sessionId={session.id}
        serviceType={session.session_info?.options}
        sessionDate={session.slots?.find(slot => slot.isPrimary)?.start_date || session.start_date}
      />
      <ReactTooltip place='top' delayHide={200} textColor='#FFF' backgroundColor='#4B5563' effect='solid' />
    </>
  );
};

export default SessionDetails;
